import CryptoJS from 'crypto-js';

const HEX = '00000000000000000000000000000000';

//iv向量
export const iv = () => {
  let str = '';
  for (let i = 0; i < HEX.length - 1; i += 2) {
    str += String.fromCharCode(parseInt('00', 16));
  }
  return str;
};

// 加密
export const Encrypt = (data, key) => {
  let key1 = CryptoJS.SHA256(CryptoJS.enc.Utf8.parse(key));
  let encrypted = CryptoJS.AES.encrypt(data, key1, {
    iv: CryptoJS.enc.Utf8.parse(iv()),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
};
// //解密方法
export const Decrypt = (data, key) => {
  let key1 = CryptoJS.SHA256(CryptoJS.enc.Utf8.parse(key));
  let decrypted = CryptoJS.AES.decrypt(data , key1, {
    iv: CryptoJS.enc.Utf8.parse(iv()),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
}

export const base64Decrypt = (data) => {
  let parsedWordArray = CryptoJS.enc.Base64.parse(data);
  let parsedStr = parsedWordArray.toString(CryptoJS.enc.Utf8);
  return parsedStr
}